import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';

import Orders from '@/components/myaccount/Routes/Orders';
import { useAuthenticated } from '@/components/shopping_bag/hooks/useAuthenticated';
import { redirectToSignin } from '@/tscapi/utils/session';

const OrderInvoiceApp = () => {
    const isAuthenticated = useAuthenticated();

    useEffect(() => {
        if (!isAuthenticated) {
            redirectToSignin({ reason: 'sessionexpired', targetUrl: '/pages/orderinvoice' });
        }
    }, [isAuthenticated]);

    if (!isAuthenticated) return null;

    return <Orders />;
};

const element = document.getElementById('orderinvoice-app') as HTMLElement;

if (element) {
    const root = ReactDOM.createRoot(element);
    const client = new QueryClient({
        defaultOptions: {
            queries: {
                cacheTime: 1000 * 60 * 60 * 24,
                staleTime: 1000 * 30,
            },
        },
    });

    root.render(
        <React.StrictMode>
            <QueryClientProvider client={client}>
                <OrderInvoiceApp />
            </QueryClientProvider>
        </React.StrictMode>,
    );
}
